import { Modal } from "react-bootstrap";
import "./masterTargetingActionnAlertModal.css";
import infoIcon from "../../../assets/icons/infoOnHoverIcon.png";
import SecondaryBtnRb from "../../Buttons/secondaryBtnRb/secondaryBtnRb";
import { useSelector, useDispatch } from "react-redux";
import { campaignListActions } from "../../../redux/slices/campaignList";

const MasterTagetinngActionAlertMModal = (props) => {
  const dispatch = useDispatch();
  const isVisible = useSelector(
    (state) => state.campaignListData.actionAlertModalVisibilty
  );

  const handleYes = () => {
    dispatch(campaignListActions.hideActionAlertModal());
    props.onYesClick?.();
  };

  const handleNo = () => {
    dispatch(campaignListActions.hideActionAlertModal());
    props.onNoClick?.();
  };

  return (
    <Modal
      size="md"
      centered
      show={isVisible}
      dialogClassName="confirmation-modal"
      contentClassName="confirmation-modal-content"
    >
      <Modal.Body>
        <div className="modal-header-section">
          <img src={infoIcon} alt="info" className="modal-info-icon" />
          <div className="modal-message-text">{props.alertText}</div>
        </div>

        {props.alertInfo && (
          <div className="modal-subtext">{props.alertInfo}</div>
        )}

        <div className="modal-button-wrapper">
          <button className="modal-btn cancel-btn" onClick={handleNo}>
            {props.noBtnText || "Cancel"}
          </button>
          <button
            className="modal-btn confirm-btn"
            id={props.confirmationId}
            onClick={handleYes}
          >
            {props.yesBtnText || "Confirm"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MasterTagetinngActionAlertMModal;
